module.exports = "https://cdn2-fs.clearscore.com/flux/images/93afb7b3d1cba296e9692b08ee863411.jpg";